<template>
  <div :class="['row gx-2', colSpanClass, props.class]">
    <slot></slot>
  </div>
</template>
<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { computed } from 'vue';

// Components

// Composables

// Stores

// Constants and Utils

// ===============================
// PROPS & EMITS
// ===============================
const props = defineProps({
  class: {
    type: String,
    default: 'align-items-center'
  },
  colSpan: {
    type: Object,
    default: () => null,
  } 
});

// ===============================
// COMPOSABLES & STORES
// ===============================

// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================

// ===============================
// COMPUTED PROPERTIES
// ===============================
const colSpanClass = computed(() => {
  if (props.colSpan !== null) {
    const classes = [];
    Object.entries(props.colSpan).forEach(([key, value]) => {
      classes.push(`row-cols-${key}-${value}`);
    });
    return classes.join(' ');
  }
  return props.cols ? `row-cols-lg-${props.cols} row-cols-sm-2` : '';
});

// ===============================
// METHODS
// ===============================

// ===============================
// WATCHERS
// ===============================

// ===============================
// LIFECYCLE HOOKS
// ===============================

// ===============================
// EXPOSE
// ===============================

</script>